<template>
  <div class="box">
    <div class="container">
      <div class="content">
        <img class="part-img" id="part-on" src="../../../assets/datapart.png"/>
        <div class="depart-box">
          <h1><i>TO {{$t('主管部门')}}</i></h1>
          <p>{{$t('主管部门、体育协会')}}</p>
          <p>{{$t('可以通过平台查询、管理辖区内历届各机构、参赛队及运动员的')}}</p>
          <p>{{$t('参赛数据，统计排名，并根据需求提供各种统计分析结果，')}}</p>
          <p>{{$t('便于主管部门了解当地体育单位的赛事状况，')}}</p>
          <p>{{$t('对并未决策提供科学的数据依据')}}</p>
          <div class="look-btn" @click="serviceDetail">{{$t('查看详细介绍')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Department',
  components: {},
  mounted () {

  },
  data () {
    return {

    }
  },
  computed: {},
  methods: {
    serviceDetail () {
      this.$message.warn('暂未更新')
    //   this.$router.push({
    //     name:'Service',
    //     params:{
    //       index:1
    //     }
    //   })
    }
  }
}
</script>
<style lang="scss" scoped>
.box{
  width: 100%;
  position: relative;
  top:-70px;
}
.container{
  width: 100%;
  height: 600px;
  background-image: url('../../../assets/departBg.jpg');
  background-repeat: no-repeat;
  background-size: cover;
}
.content{
  width: 1200px;
  margin: 0 auto;
  color: white;
  position: relative;
}
.depart-box{
  width: 500px;
  height: 500px;
  float: right;
}
.depart-box h1{
    color: white;
    font-weight: bold;
    font-size: 40px;
    padding-top: 60px;
    margin-bottom: 50px;
}
.depart-box p{
    font-weight: bold;
    font-size: 14px;
}
.part-img{
  position: absolute;
  left: -2000px;
  top: 20px;
  transition: 0.5s;
  width: 800px;
  z-index: 999;
}
.part-on-box{
  position: absolute;
  left: -120px;
  top: 50px;
  transition: 0.5s;
}
.look-btn{
    width: 200px;
    height: 60px;
    border: 1px solid #fff;
    cursor: pointer;
    border-radius: 60px;
    margin-top: 100px;
    line-height: 60px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    opacity: 0.8;
}
.look-btn:hover{
    opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/home/components/Department.vue